import { render, staticRenderFns } from "./PointsCard.vue?vue&type=template&id=af787044&"
import script from "./PointsCard.vue?vue&type=script&lang=js&"
export * from "./PointsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports